import React, { useEffect, useState } from 'react';
import { fetchDeviations, DeviationLog } from '../../services/logistics/integrity/deviations';
import { format } from 'date-fns';
import { AlertCircle, History } from 'lucide-react';

export const CompliancePanel = ({ storeId, isAdmin }: { storeId: string, isAdmin: boolean }) => {
    const [deviations, setDeviations] = useState<DeviationLog[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isAdmin || !storeId) return;
        setLoading(true);
        fetchDeviations(storeId).then(data => {
            setDeviations(data);
            setLoading(false);
        });
    }, [storeId, isAdmin]);

    if (!isAdmin) return null;

    return (
        <div className="bg-card-bg/40 p-8 rounded-[3rem] border border-border-dim shadow-xl overflow-hidden relative group">
            <div className="absolute top-0 right-0 p-8 opacity-[0.03] group-hover:opacity-[0.05] transition-opacity">
                <History className="w-48 h-48 text-amber-500" />
            </div>

            <div className="relative z-10">
                <h3 className="text-base font-black text-text-primary uppercase tracking-widest mb-6 flex items-center gap-2">
                    <AlertCircle className="w-5 h-5 text-amber-500" /> Auditoria de Conformidade
                </h3>

                <div className="max-h-[400px] overflow-y-auto space-y-3 pr-2 scrollbar-hide">
                    {loading ? (
                        <div className="text-text-muted text-sm animate-pulse">Carregando registros...</div>
                    ) : deviations.length === 0 ? (
                        <div className="text-text-muted text-base italic p-4 text-center border border-dashed border-border-dim rounded-2xl">
                            Nenhuma divergência registrada no período.
                        </div>
                    ) : (
                        deviations.map((log, i) => (
                            <div key={i} className="bg-black/5 dark:bg-white/5 p-4 rounded-2xl border border-border-dim/50 hover:bg-black/10 dark:hover:bg-white/10 transition-colors flex flex-col gap-2 group/card">
                                <div className="flex justify-between items-start">
                                    <span className={`text-xs font-black uppercase tracking-widest px-2 py-1 rounded-lg ${log.type === 'strategy_ignore' ? 'bg-rose-500/10 text-rose-500' : 'bg-amber-500/10 text-amber-500'}`}>
                                        {log.type === 'strategy_ignore' ? 'Ignorou Sofia' : 'Ajuste Manual'}
                                    </span>
                                    <span className="text-xs text-text-muted font-mono">
                                        {format(log.timestamp, 'dd/MM HH:mm')}
                                    </span>
                                </div>
                                <p className="text-sm text-text-secondary font-medium leading-relaxed pl-1 border-l-2 border-border-dim group-hover/card:border-sal-cyber-teal transition-colors">
                                    "{log.reason}"
                                </p>
                                <div className="flex justify-between items-center text-xs text-text-muted font-bold uppercase tracking-wider pt-2 mt-1 border-t border-border-dim/30">
                                    <span className="truncate max-w-[120px]">{log.dispatcherId?.split('@')[0] || 'Unknown'}</span>
                                    <span className="text-sal-cyber-teal">{log.strategyName || log.adjustmentType?.toUpperCase()}</span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};
